import { createStore } from 'vuex'

export default createStore({
  state: {
    selectedFontStyle: 'ashkenaz',
    selectedFontSize: 20,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
